import React, { useEffect } from 'react';
import { Card } from 'antd';
import { useParams } from 'react-router-dom';

import EnrollSelect from './EnrollSelect';
import FeedbackTable from '../table/FeedbackTable';

const Feedbacks = (props) => {
  const {
    isLoading,
    studentObj,
    getCourseListOfStudent,
    enrollCourseList,
    fetchOneStudentFeedbackList,
    oneStudentFeedbackList,
    feedbackDataSource,
    columns,
  } = props;
  const studentId = useParams().id;

  useEffect(() => {
    if (studentId && getCourseListOfStudent) {
      getCourseListOfStudent(studentId);
    }
  }, [getCourseListOfStudent, studentId]);

  let courseName =
    studentObj.currentEnrollmentName != null
      ? studentObj.currentEnrollmentName
      : '没有进行的课程';
  const courseTitle = '当前课程: ' + courseName;
  return (
    <>
      <Card title={courseTitle}>
        <EnrollSelect
          studentObj={studentObj}
          getCourseListOfStudent={getCourseListOfStudent}
          enrollCourseList={enrollCourseList}
          fetchOneStudentFeedbackList={fetchOneStudentFeedbackList}
          feedbackDataSource={feedbackDataSource}
        />
      </Card>
      <Card title='学生上课记录' style={{ margin: '10px 0' }}>
        <FeedbackTable
          isLoading={isLoading}
          oneStudentFeedbackList={oneStudentFeedbackList}
          feedbackTableColumn={columns}
          enrollCourseList={enrollCourseList}
          fetchOneStudentFeedbackList={fetchOneStudentFeedbackList}
        />
      </Card>
    </>
  );
};

export default Feedbacks;
